import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const ConsultingArchitecture = () => {
    const capabilities = [
        {
          title: "Digital Transformation Roadmaps",
          description:
            "End-to-end guidance to help you migrate, modernize, and reimagine your business through digital-first strategies.",
          image: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500",
        },
        {
          title: "Enterprise Architecture Design",
          description:
            "Structured frameworks (TOGAF, Zachman, etc.) to align IT systems with business goals.",
          image: "https://images.pexels.com/photos/3861964/pexels-photo-3861964.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500",
        },
        {
          title: "Data & Analytics Architecture",
          description:
            "Enable smarter decisions through robust data integration, governance, and predictive analytics.",
          image: "https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg",
        },
        {
          title: "Sustainability-Centric IT Planning",
          description:
            "Architect eco-friendly, cost-efficient infrastructures that align with ESG goals.",
          image: "https://images.pexels.com/photos/371900/pexels-photo-371900.jpeg",
        },
        {
          title: "M&A IT Integration",
          description:
            "Proven frameworks to unify systems, data, and operations post-merger — with minimal downtime.",
          image: "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg",
        },
        {
          title: "Cloud Strategy & Migration",
          description:
            "Platform-agnostic consulting across AWS, Azure, and Google Cloud.",
          image: "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
        },
        {
          title: "Cybersecurity Architecture",
          description:
            "Zero-trust frameworks, risk assessments, and policy design to protect your digital assets.",
          image: "https://images.pexels.com/photos/1181248/pexels-photo-1181248.jpeg",
        },
      ];
      
  return (
    <div>
      <Helmet>
        <title>IT Consulting & Architecture Services | Dhanam Infosys</title>
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <section className="about-hero text-white text-center py-5">
        <Container>
          <h1 className="fw-bold mb-3">IT Consulting & Architecture Services</h1>
          <p className="lead">
            Transforming Businesses Through Strategy, Innovation, and Future-Ready Technology
          </p>
        </Container>
      </section>

      {/* Intro Section */}
      <section className="py-5 bg-light">
  <Container>
    <Row className="align-items-center">
      <Col xs={12} md={6} className="mb-4 mb-md-0">
        <img
          src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
          alt="IT Services"
          className="img-fluid rounded-4 shadow"
        />
      </Col>
      <Col xs={12} md={6} className="text-center text-md-start">
        <p className="fs-5">
          At <strong>Dhanam Information Systems</strong>, we offer expert IT consulting and enterprise architecture services
          designed to help organizations adapt, scale, and lead in the digital age. Whether you're modernizing legacy systems,
          preparing for a digital transformation, or planning a merger or acquisition, our strategic approach ensures seamless
          integration and long-term value.
        </p>
      </Col>
    </Row>
  </Container>
</section>

      {/* Capabilities Section */}
      <section className="py-5">
        <Container>
          <h2 className="text-center fw-bold mb-5" style={{ color: "rgb(11, 22, 63)" }}>
            Our Core Capabilities
          </h2>
          <Row className="g-4">
            {capabilities.map((item, index) => (
              <Col md={6} lg={4} key={index}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={item.image}
                    className="card-img-top"
                    alt={item.title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center text-md-start">
  <h5 className="card-title text-primary">{item.title}</h5>
  <p className="card-text">{item.description}</p>
</div>

                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Why Choose Section */}
      <section className="py-5 bg-light">
  <Container>
    <h2 className="text-center fw-bold mb-4" style={{ color: "rgb(11, 22, 63)" }}>
      Why Choose Dhanam Information Systems?
    </h2>
    <div className="row justify-content-center">
      <div className="col-lg-8 col-md-10">
        <ul className="list-unstyled fs-5 text-center text-md-start">
          <li className="mb-3 text-nowrap overflow-auto">
            ✅ 25+ years of industry experience
          </li>
          <li className="mb-3 text-nowrap overflow-auto">
            ✅ Proven track record with enterprise clients
          </li>
          <li className="mb-3 text-nowrap overflow-auto">
            ✅ Certified consultants and solution architects
          </li>
          <li className="mb-3 text-nowrap overflow-auto">
            ✅ Focus on value-driven, sustainable IT ecosystems
          </li>
        </ul>
      </div>
    </div>
  </Container>
</section>


      {/* CTA Section */}
      <section className="about-hero text-white text-center py-5">
        <Container>
          <h4 className="mb-2">Ready to Transform Your IT Infrastructure?</h4>
          <p className="mb-3">Talk to our certified consultants today and start your digital journey.</p>
          <a href="/contact-us" className="btn btn-light text-primary fw-bold">Contact Us</a>
        </Container>
      </section>

      <Footer />

      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }
        ul {
          list-style: none;
          padding-left: 0;
        }
        ul li {
          margin-bottom: 10px;
        }
        ul li {
          white-space: nowrap;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        
      `}</style>
    </div>
  );
};

export default ConsultingArchitecture;
